var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgPlayinline = function SvgPlayinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#EE424E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.281 5.939c-.33-.2-.748.044-.748.438v11.78c0 .395.418.64.748.438l9.676-5.89a.516.516 0 000-.876L9.281 5.94z",
    fill: "#fff"
  })));
};
export default SvgPlayinline;